import type { LayerState } from '@vitals/shared';
import type { VitalDef, VitalView } from './vitals.js';

/**
 * Citi Bike vital selector.
 * Reads `summary.{ bikes, pctDocksEmpty }` from the GBFS LayerState.
 * Returns `down: true` with a '—' value when the feed is unavailable.
 */
export const bikesVital: VitalDef = {
  id: 'bikes',
  layerId: 'citibike',
  select: (s: LayerState | undefined): VitalView => {
    const isDown = !s || s.status === 'down' || s.summary == null;

    if (isDown) {
      return {
        value: '—',
        label: 'bikes',
        down: true,
        stale: false,
      };
    }

    const summary = s.summary as { bikes: number; pctDocksEmpty: number };
    const bikes = summary.bikes.toLocaleString('en-US');

    return {
      value: bikes,
      label: 'bikes',
      down: false,
      stale: s.status === 'stale',
    };
  },
};
